import React from 'react';
import { Create, SimpleForm, TextInput, required, DateInput, ReferenceInput, SelectInput } from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";
import { BooleanInput } from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
export const ActivityCreate = props => {
    let defaultValues = {
        is_show_qty: false,
    };
    return (
        <React.Fragment>
            <Create label="Edit Facility" {...props}>
                <SimpleForm redirect="list" initialValues={defaultValues}
                    toolbar={<FormToolbar {...props} />}
                    variant="outlined">
                    <ReferenceInput label="Category" source="category_id" reference="category" fullWidth={true}
                        sort={{ field: 'name', order: 'asc' }}>
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <TextInput source="name" fullWidth={true} validate={[required()]} />
                    <RichTextInput source="description" fullWidth={true} />
                    <BooleanInput source="is_show_qty" fullWidth={true} validate={[required()]} />
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
}